import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import qestIds from 'Components/Worksheets/QestIds';
import getLabelConfig from 'Components/Worksheets/WashWorksheet/BsEn/Config/labelConfig';
import getDerivedFromMeasurementsConfig from './derivedFromMeasurementsConfig';
import getMeasuredUsingConfig from './measuredUsingConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTrays.DryMassReadings.DryingTime`]: {
        uom: 'h',
        format: { nearest: 0.1 },
      },
      [`${prefix}.Masses.MeasuredScreeningsConstantDryMass.DryingTrays.DryMassReadings.DryingTime`]: {
        uom: 'h',
        format: { nearest: 0.1 },
      },
      [`${prefix}.Results.PercentPassingWashingSieve`]: { format: { nearest: 0.1 } },
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Equipment.InitialBalance`]: { defaultReadability: 0.1, defaultUom: 'g' },
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.DryMassBalance`]: {
        defaultReadability: 0.1,
        defaultUom: 'g',
      },

      [`${prefix}.Masses.MeasuredScreeningsConstantDryMass.Equipment.DryMassBalance`]: {
        defaultReadability: 0.1,
        defaultUom: 'g',
      },
    },
    getLabelConfig(prefix)
  );

export { getConfig };

export default {
  [qestIds.wash.BS_EN_933_1.Rev2012]: getConfig,
};
